import { trueFalseToBoolean } from './helpers.utils';
import {
    LOGIN_STATUS as loginStat, NODE_ENVIRONMENTS as nodeEnv
    , APIHEADERS
    , APIHEADERSTOKENONLY
    , DEVSTRING
    , METHODS
} from '../utils/constant.utils';

export async function httpGet(url, options) {
    options = setOptions(options, METHODS.GET, null, url);

    url = new URL(apiEndPoint() + url);
   
    const response = await fetch(url, options);
    const jsonData = response.ok !== false ? response.json() : response;

    return jsonData;
}

export const httpPost = async (url, data, options) => {
    try {
        options = setOptions(options, METHODS.POST, data, url);

        const baseUrl = apiEndPoint();
        url = new URL(url, baseUrl);

        const response = await fetch(url, options);

        // Ensure response is OK before parsing JSON
        if (!response.ok) {
            const jsonData = await response.json();
            return jsonData;
        }

        // Check if response body is empty
        const text = await response.text();
        if (!text) {
            return {}; // Return an empty object instead of trying to parse empty JSON
        }

        // Check if response is actually JSON before parsing
        if (response.headers.get("content-type")?.includes("application/json")) {
            return JSON.parse(text);
        } else {
            console.warn("Warning: Response is not JSON", text);
            return text; // Return raw response if not JSON
        }
    } catch (error) {
        console.error("Error in httpPost:", error);
        return { error: error.message };
    }
};

export async function httpPostFile(url, data, options) {
    options = setOptions(options, METHODS.POST_FILE, data, url);

    url = new URL(apiEndPoint() + url);

    const response = await fetch(url, options);
    const jsonData = response.ok !== false ? response.json() : response;

    return jsonData;
}

export const httpDownload = async (url, data, options) => {
    options = setOptions(options, METHODS.DOWNLOAD, data, url);
    var baseUrl = apiEndPoint();
    url = new URL(url, baseUrl);
    const response = await fetch(url, options);

    return response;
}

export const httpExtract = async (url, data, options = {}, isFile = false) => {
    let method = isFile ? METHODS.POST_FILE : METHODS.POST;
    options = setOptions(options, method, data, url);
  
    const baseUrl = apiEndPoint();
    url = new URL(url, baseUrl);
    const response = await fetch(url, options);

    if(isFile){
        return response;
    }else{
        const jsonData = response.ok !== false ? await response.json() : response;
        return jsonData;
    }
};

function setOptions(options, method, data, url) {
    var ajaxHeader = getAjaxHeader(url);
    options = {
        ...options,
        ...{
            method: METHODS.POST_FILE !== method ? method : method.POST
        }
    };

    switch (method) {
        case METHODS.GET:
            options = {
                ...options,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    ...ajaxHeader
                },
            };
            break;
        case METHODS.POST:
            options = {
                ...options,
                headers: {
                    'Content-type': 'application/json',
                    ...ajaxHeader
                },
                contentType: "application/json; charset=utf-8",
                credentials: "include",
                body: JSON.stringify(data)
            };
            break;
        case METHODS.POST_FILE:
            var newHeaders = JSON.parse(JSON.stringify(getAjaxHeader()));
            delete newHeaders['content-type'];
            options = {
                method: 'POST',
                headers: newHeaders
            }
            options.body = data;
            break;
        case METHODS.DOWNLOAD:
            options = {
                method: 'POST',
                headers: ajaxHeader,
                credentials: "include",
                body: JSON.stringify(data)
            };
            break;
        default:
            break;
    }

    return options;
}


function getAjaxHeader(url) {
    const shouldValidate = (url == undefined) ? true : !url.includes("external/login") && !url.includes("login/logOut") && !url.includes("getUserInfo");
    var aadEnabledInt = trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE);
    if (
        sessionStorage.logInStatus == loginStat.internal
        && aadEnabledInt
        && document.cookie === ""
        && shouldValidate
        && process.env.NODE_ENV !== nodeEnv.dev
    ) {
        // sessionStorage.clear();
        // UserManager.clearStaleState();
        //UserManager.removeUser();
        //UserManager.signoutRedirect();
    }

    return APIHEADERS;
}

var SetCSRFToken = function () {
    const tCSRFToken = getCookie("CSRF-TOKEN");
    APIHEADERS["X-CSRF-TOKEN"] = tCSRFToken;
    APIHEADERS.RequestVerificationToken = tCSRFToken;

    APIHEADERSTOKENONLY["X-CSRF-TOKEN"] = tCSRFToken;
    APIHEADERSTOKENONLY.RequestVerificationToken = tCSRFToken;
}

var getCookie = function (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function setAuthToken (acces_token) {
    APIHEADERS["access-token"] = acces_token;
    APIHEADERS.Authorization = "Bearer " + acces_token;

    APIHEADERSTOKENONLY["access-token"] = acces_token;
    APIHEADERSTOKENONLY.Authorization = "Bearer " + acces_token;
    SetCSRFToken();
}

export const GetAjaxHeaderTokenOnly = (tShouldValidate) => {
    const shouldValidate = tShouldValidate == undefined;
    var aadEnabledInt = trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE);
    if (
        aadEnabledInt
        && document.cookie === ""
        && shouldValidate
        && process.env.NODE_ENV !== nodeEnv.dev
    ) {
        // sessionStorage.clear();
        // UserManager.clearStaleState();
        // UserManager.removeUser();
        //UserManager.signoutRedirect();
    }
    return APIHEADERSTOKENONLY;
}

const apiEnpoints = Object.keys(process.env)
    .filter(key => key.includes('REACT_APP_APIHTTPS'))
    .reduce((obj, key) => {
        obj[key.replace('REACT_APP_APIHTTPS', "")] = process.env[key];
        return obj;
    }, {});

export const apiEndPoint = () => {
    return (process.env.NODE_ENV !== DEVSTRING)
    ? apiEnpoints[Object.keys(apiEnpoints)[0]]
    : "http://localhost:52919/api/";
}


